import { getProfitAndLossMonthly } from "@/services/profit-and-loss-monthly-api";
import { ProfitAndLossMonthlyData } from "@/types/profit-and-loss-monthly-api";
import { callApiWithChecks } from "./use-template";

type YM = { year: number; month: number };
type RangeFilter = { from: YM; to: YM };

export function useProfitAndLossMonthlyRange(
  clientId: string,
  connectionId: string,
  range: RangeFilter,
  enabled: boolean
) {
  const key = `${range.from.year}-${range.from.month}|${range.to.year}-${range.to.month}`;

  return callApiWithChecks<ProfitAndLossMonthlyData>(
    () =>
      getProfitAndLossMonthly(
        clientId,
        [connectionId],
        range.from.year,
        range.from.month,
        range.to.year,
        range.to.month
      ),
    [clientId, connectionId, key],
    enabled,
    {
      title: "Error",
      description: "Failed to load profit & loss (monthly) report",
    }
  );
}
